const STORAGE_KEY = "beyundai.backgroundJobs.v1";

export function loadBackgroundJobs() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function saveBackgroundJobs(jobs) {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(jobs));
  } catch {
    /* ignore quota errors */
  }
}

export function jobKey(type, externalId) {
  return `${type}:${externalId}`;
}
